/* eslint-disable import/prefer-default-export */
export function getLabel (srcLang) {
  switch (srcLang) {
    case 'ar':
      return 'عربى'
    case 'cs':
      return 'čeština'
    case 'de':
      return 'Deutsch'
    case 'en':
      return 'English'
    case 'es':
      return 'Español'
    case 'fr':
      return 'Français'
    case 'it':
      return 'Italiano'
    case 'ja':
      return '日本語'
    case 'pt':
      return 'Português'
    case 'ru':
      return 'русский'
    case 'zh':
      return '中文'
    default:
      return srcLang
  }
}

export function getSrcLang (label) {
  switch (label.toLowerCase()) {
    case 'عربى':
      return 'ar'
    case 'čeština':
      return 'cs'
    case 'deutsch':
      return 'de'
    case 'english':
      return 'en'
    case 'español':
      return 'es'
    case 'français':
      return 'fr'
    case 'italiano':
      return 'it'
    case '日本語':
      return 'ja'
    case 'português':
      return 'pt'
    case 'русский':
      return 'ru'
    case '中文':
      return 'zh'
    default:
      return label
  }
}
